<nz-slider
  ngDefaultControl
  #firstnameControl="ngModel"
  [name]="config.name"
  [(ngModel)]="config.value"
  [nzDisabled]="config.disabled"
></nz-slider>
